import { Component, OnInit, OnDestroy, HostListener, ViewChild, TemplateRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportsService } from 'src/app/components/services/reports/reports.service';
import { AuthenticationService } from 'src/app/shared/service/authentication.service';

@Component({
  selector: 'app-reports-by-user',
  templateUrl: './reports-by-user.component.html',
  styleUrls: ['./reports-by-user.component.scss']
})
export class ReportsByUserComponent implements OnInit, OnDestroy {

  private subs: Array<Subscription> = [];
  private modalContent: any;
  private modalConfig: any = {
    ariaLabelledBy: 'modal-basic'
  };

  public reports: any;
  public reportsList: any[] = [];
  public statusFilters: any[] = [];
  public total: number;
  public limit = 10;
  public status = 'Total';
  public loading = false;
  public loadingDetail = false;
  public hasMore = true;
  public reportId: string;
  public selectedReport: any;

  @ViewChild('reportDetailModal') reportDetailModal: TemplateRef<any>;

  constructor(
    private reportService: ReportsService,
    private authService: AuthenticationService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.loadReports(true);
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (this.loading || !this.hasMore || !this.reportsList.length) return;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    if (scrollTop + clientHeight >= scrollHeight - 200) {
      this.loadReports(false);
    }
  }

  loadReports(reset: boolean): void {
    if (this.loading) return;
    if (reset) {
      this.reportsList = [];
      this.hasMore = true;
    }
    this.loading = true;
    const page = Math.floor(this.reportsList.length / this.limit);
    this.subs.push(
      this.reportService
        .getReportsByUser(
          this.authService.currentUserValue.email,
          this.limit,
          page,
          this.status
        )
        .pipe(catchError(err => this.authService.handleUnauthorizedError(err)))
        .subscribe(data => {
          this.reports = data;
          this.statusFilters = data.status || [];
          this.total = data.Total || 0;
          const newReports = data.reports || [];
          this.reportsList = reset ? newReports : [...this.reportsList, ...newReports];
          this.hasMore = newReports.length >= this.limit;
          this.loading = false;
        }, () => {
          this.loading = false;
        })
    );
  }

  setModalContent(content: any, reportId: string): void {
    this.reportId = reportId;
    this.modalContent = content;
    this.modalService.open(this.modalContent, this.modalConfig);
  }

  assignModalContent(contentArea: any, reportId: string): void {
    this.reportId = reportId;
    this.modalContent = contentArea;
    this.modalService.open(this.modalContent, this.modalConfig);
  }

  openReportDetail(reportId: string | number): void {
    this.loadingDetail = true;
    this.selectedReport = null;
    this.modalService.open(this.reportDetailModal, { size: 'xl', ...this.modalConfig });
    this.subs.push(
      this.reportService
        .getReport(reportId)
        .pipe(catchError(err => this.authService.handleUnauthorizedError(err)))
        .subscribe(
          (report) => {
            this.selectedReport = report;
            this.loadingDetail = false;
          },
          () => {
            this.loadingDetail = false;
          }
        )
    );
  }
}

